import { SVGProps, Ref, forwardRef } from 'react';

export const MediumSolidSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.544 1H3.456A2.456 2.456 0 0 0 1 3.456v9.088C1 13.9 2.1 15 3.456 15h9.088C13.9 15 15 13.9 15 12.544v-.638a3 3 0 0 1-.246.012c-1.503 0-2.35-1.252-2.386-2.818a5 5 0 0 1 .005-.292l.003-.06.005-.062c.054-.691.277-1.307.644-1.762a2.27 2.27 0 0 1 1.785-.856h.013q.09 0 .177.006V3.456C15 2.1 13.9 1 12.544 1m-.102 3.342-.01.002c-.412.093-.621.232-.621.731h-.002l.002 5.994c.035.394.247.516.62.6l.011.003v.085H9.571v-.085l.01-.003c.374-.084.58-.206.616-.6v-5.83l-2.768 6.504h-.152l-2.69-6.328v5.51c0 .499.21.637.62.73l.012.003v.085H3.57v-.086l.011-.002c.412-.093.621-.231.621-.731V5.075c0-.5-.208-.638-.62-.73l-.01-.003v-.085H6l2.093 4.92 2.094-4.92h2.254z"
            fill="currentColor"
        />
        <path d="M15 8.515v2.12c-.784-.23-1.344-1.096-1.286-2.12z" fill="currentColor" />
        <path d="M15 6.424v1.795h-1.257c.047-1.051.424-1.81 1.057-1.823q.107.002.2.028" fill="currentColor" />
    </svg>
));
MediumSolidSize16Glyph.displayName = 'MediumSolidSize16Glyph';
